import { ContextModalProps } from '@mantine/modals'
import DeliveryCompanyForm from 'components/orders/DeliveryCompanyForm'
import { useAddDeliveryCompany } from 'hooks/orders'

export default function AddDeliveryCompanyModal({ context, id }: ContextModalProps) {
  const addDeliveryCompany = useAddDeliveryCompany()
  return (
    <DeliveryCompanyForm
      onClose={() => context.closeContextModal(id)}
      onSubmit={async (values) => {
        await addDeliveryCompany.mutateAsync(values)
      }}
    />
  )
}
